import React from "react";
import { Loader } from "components/commons";
import styles from "./shift-details-stock-inventory.module.scss";
import ShiftDetailsDryStockSalesLubricant from "./shift-details-stock-inventory-dry-stock-sales-lubricant";
import ShiftDetailsDryStockSalesLpg from "./shift-details-stock-inventory-dry-stock-sales-lpg";
import ShiftRecordDryStockMovement from "./shift-records-dry-stock-inventory-movement";
import ShiftDetailsDryStockDeliveries from "./shift-records-dry-stock-inventory-deliveries";
import useProducts from "hooks/useProducts";

const ShiftRecordsDetailsStockInventoryDryModule = (props) => {
  const { inventory, setInventory, loadingShift, shift, form, pageMode, loadingProducts } = props;
  const { allProducts } = useProducts({ withStationCode: false });

  return (
    <>
      <Loader open={loadingShift || loadingProducts} />
      {shift && allProducts.length > 0 && !loadingShift && !loadingProducts && (
        <div className={styles.container}>
          <ShiftRecordDryStockMovement
            shift={shift}
            form={form}
            pageMode={pageMode}
            inventory={inventory}
            setInventory={setInventory}
            allProducts={allProducts}
          />
          <ShiftDetailsDryStockDeliveries shift={shift} allProducts={allProducts} />
          <ShiftDetailsDryStockSalesLubricant shift={shift} allProducts={allProducts} />
          <ShiftDetailsDryStockSalesLpg shift={shift} />
        </div>
      )}
    </>
  );
};

export default ShiftRecordsDetailsStockInventoryDryModule;
